import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../shared/storage.service';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FooterService } from '../../components/footer/footer.service';
declare const $: any;


@Component({
  selector: 'app-medications',
  templateUrl: './medications.component.html',
  styleUrls: ['./medications.component.css']
})
export class MedicationsComponent implements OnInit {
  medicationsForm: FormGroup;
  allergiesForm: FormGroup;
  medicationList: any[] = [];
  travelerHistoryDataList: any = [];
  TravelerId: string = '';
  allergiesList: any = [];

  constructor(
    public storageService: StorageService,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private footerService: FooterService
  ) { }

  ngOnInit(): void {
    this.footerService.hideFooter();
    this.route.queryParams.subscribe(params => {
      this.TravelerId = params['travelerId'];
    });
    this.getTravelerHistoryData();
    this.defaultMedicationForm();
    this.defaultAllergiesForm();
  }

  defaultAllergiesForm() {
    this.allergiesForm = this.fb.group({
      allergyName: ['', Validators.required]
    });
  }

  defaultMedicationForm() {
    this.medicationsForm = this.fb.group({
      medicationName: ['', Validators.required],
      dosage: ['', Validators.required],
      frequency: ['', Validators.required]
    });
  }

  getTravelerHistoryData() {
    this.userLayoutService.getMedicalHistryByTravelerId(this.TravelerId).subscribe((Response: any) => {

      if (Response.code == 1) {
        this.travelerHistoryDataList = Response.data;
        this.medicationList = this.travelerHistoryDataList?.medications;
        this.allergiesList = this.travelerHistoryDataList?.allergies;
        // console.log("TravelerHistoryData", this.travelerHistoryDataList, this.medicationList, this.allergiesList);
      }
      else {
        // console.log(Response.error);
      }
    }, (error) => {
      // console.log(error.error.Message);
    });
  }

  onMedicationAdd(): void {
    if (this.medicationsForm.valid) {
      this.medicationList.push(this.medicationsForm.value);
      this.defaultMedicationForm();
      $("#medicationsForm").modal("hide");
      // this.medicationsForm.reset();
    }
    // console.log(this.medicationsForm.valid, this.medicationsForm.value, "*****", this.medicationList);
  }

  onAllergyAdd(): void {
    if (this.allergiesForm.valid) {
      this.allergiesList.push(this.allergiesForm.value);
      this.defaultAllergiesForm();
      $("#allergiesForm").modal("hide");
    }
    // console.log(this.allergiesForm.valid, this.allergiesForm.value, "*****", this.allergiesList);

  }

  // Cancel button handler to reset the form
  cancel(): void {
    this.defaultMedicationForm();
    this.defaultAllergiesForm();
  }

  removeAllergies(index: number): void {
    this.allergiesList.splice(index, 1);
  }

  removeMedication(index: number): void {
    this.medicationList.splice(index, 1);
  }

  saveMedicalHistory() {
    if (this.allergiesList.length > 0 || this.medicationList.length > 0) {
      const medicalHistoryObj = {
        travellerInfoId: this.TravelerId,
        allergies: this.allergiesList,
        medications: this.medicationList.map(med => ({
          medicationName: med.medicationName,
          dosage: med.dosage,
          frequency: med.frequency
        }))
      };
  
  
      // Send the payload to the API
      this.userLayoutService.saveMedicalHistoryData(medicalHistoryObj).subscribe(
        (response: any) => {
          if (response.code === 1) {
            this.commonService.notifier.notify('success', 'Medication Details Save Succesfully');
            this.getTravelerHistoryData();
  
          } else {
            this.commonService.notifier.notify('error', response.message);
          }
        },
        (error) => {
          console.error('API Error:', error);
          this.commonService.notifier.notify('error', error);
        }
      );
    }
    
  }

  backToBooking() {
    this.router.navigate(['/bookings']);
  }
}